import { buildWhatsAppUrl } from "@/lib/whatsapp-link"

/**
 * `wa.me` link that opens the store chat prefilled with the tracking request. Null when the merchant number is
 * unknown or the store already pushes the order status over WhatsApp (`statusOverWhatsapp`; today the storefront
 * does not receive that setting, so callers omit it and the button shows whenever a number is known).
 */
export function followOrderWhatsAppUrl(
  phone: string | null | undefined,
  displayId: string,
  statusOverWhatsapp?: boolean,
): string | null {
  if (statusOverWhatsapp) return null
  return buildWhatsAppUrl({ phone, message: `Quero acompanhar meu pedido #${displayId}` })
}
